/**
 * Small helper that creates an array of actual numbers, starting from 0 up to the given length minus 1.
 *
 * @param length
 * @returns array of numbers
 */
export const fillArray = (length: number): number[] => Array.from({ length }, (_, index) => index);
